import routes from 'apps/student/routes';
import { TrackingContext } from '@lingoda/analytics';
import { FFreeTrialCountdownNotificationBar } from '@lingoda/f-free-trial';
import { NotificationBars } from '@lingoda/membership';
import { type RouteConfigOption } from '@lingoda/router';
import {
    TimezoneDifferencesBar,
    useShouldShowTimezoneDifferenceBar,
} from '@lingoda/student-frontend/components';
import { HeaderPortalSlot, PublicHeader, StudentHeader } from '@lingoda/student-navigation';
import { FixedPageHeader } from '@lingoda/ui';

interface HeaderRefs {
    navHeader: (ref: HTMLDivElement | null) => void;
    notificationBars: (ref: HTMLDivElement | null) => void;
    timezoneBanner: (ref: HTMLDivElement | null) => void;
    fFreeTrialCountdown: (ref: HTMLDivElement | null) => void;
}

interface Props
    extends Required<
        Pick<
            RouteConfigOption,
            'logoIsIcon' | 'disableLogoLink' | 'hideNavigation' | 'headerIsPortal'
        >
    > {
    refs: HeaderRefs;
}

export const PrivatePageHeader = (props: Props) => {
    const { headerIsPortal, hideNavigation, refs } = props;
    const {
        isShown: isTimezoneBarShown,
        dismiss: dismissTimezoneBar,
        localTimezone,
    } = useShouldShowTimezoneDifferenceBar();

    return (
        <TrackingContext section="Header">
            <FixedPageHeader elevation={1}>
                {isTimezoneBarShown && (
                    <TimezoneDifferencesBar
                        ref={refs.timezoneBanner}
                        dismissBar={dismissTimezoneBar}
                        localTimezone={localTimezone}
                    />
                )}
                <FFreeTrialCountdownNotificationBar ref={refs.fFreeTrialCountdown} />

                {headerIsPortal ? (
                    <HeaderPortalSlot ref={refs.navHeader} />
                ) : hideNavigation ? (
                    <PublicHeader
                        elevation={1}
                        ref={refs.navHeader}
                        logoIsIcon={props.logoIsIcon}
                        disabledLogo={props.disableLogoLink}
                        hideNavigation={props.hideNavigation}
                    />
                ) : (
                    <StudentHeader ref={refs.navHeader} routes={routes} />
                )}

                <NotificationBars ref={refs.notificationBars} />
            </FixedPageHeader>
        </TrackingContext>
    );
};
